import css from 'styled-jsx/css';

const styles = css.global`.rotoql-player__item{border-top:solid 1px #f5f5f5}`;

export default styles;